import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Header } from "../Components";
import { useParams } from "react-router-dom";

const CustomerLinkRequest = () => {
  const { platform } = useParams();

  const [dialogVisible, setDialogVisible] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);

  // ✅ Dummy Data (Added Post Data)
  const allData = {
    facebook: [
      {
        cust_id: "CUST001",
        name: "Rahul Patel",
        package: "Facebook",
        link: "https://facebook.com/post/123",
        joined_by: "Jenil Chavda",
        admin_id: "343434245",
        date: "24 Mar 2026, 11:30 AM",

        post: {
          text: "This is Facebook post content",
          image: "https://via.placeholder.com/400x250.png?text=FB+Image",
          video: "https://www.w3schools.com/html/mov_bbb.mp4",
          audio: "",
        },
      },
    ],
    youtube: [
      {
        cust_id: "CUST002",
        name: "Amit Shah",
        package: "YouTube",
        link: "https://youtube.com/watch?v=abc123",
        joined_by: "Mitesh Chavda",
        admin_id: "99887766",
        date: "23 Mar 2026, 4:10 PM",

        post: {
          text: "YouTube video description",
          image: "",
          video: "https://www.w3schools.com/html/mov_bbb.mp4",
          audio: "",
        },
      },
    ],
  };

  const data = allData[platform] || [];

  // 🖼️ Open Post Dialog
  const openPost = (post) => {
    setSelectedPost(post);
    setDialogVisible(true);
  };

  // 👤 Customer
  const customerBody = (row) => (
    <div>
      <div className="font-semibold">{row.name}</div>
      <div className="text-sm text-gray-500">{row.cust_id}</div>
    </div>
  );

  // 👥 Joined By
  const joinedByBody = (row) => (
    <div>
      <div className="font-semibold">{row.joined_by}</div>
      <div className="text-sm text-gray-500">({row.admin_id})</div>
    </div>
  );

  // 🔗 Link
  const linkBody = (row) => (
    <a
      href={row.link}
      target="_blank"
      rel="noreferrer"
      className="text-blue-600 underline"
    >
      View Link
    </a>
  );

  // 🧠 Post Column (NEW)
  const postBody = (row) => (
    <Button
      label="View"
      icon="pi pi-eye"
      className="p-button-sm p-button-secondary"
      onClick={() => openPost(row.post)}
    />
  );

  // ⚡ Action
  const actionBody = () => (
    <div className="flex gap-2">
      <Button
        label="Accept"
        icon="pi pi-check"
        className="p-button-success p-button-sm"
      />
      <Button
        label="Cancel"
        icon="pi pi-times"
        className="p-button-danger p-button-sm"
      />
    </div>
  );

  return (
    <div className="max-w-7xl mx-auto p-6">
      <Header
        category="Customer"
        title={`${
          platform === "youtube" ? "YouTube" : "Facebook"
        } Link Requests`}
      />

      <DataTable value={data} paginator rows={10}>
        <Column field="cust_id" header="Cust ID" />
        <Column header="Customer Name" body={customerBody} />
        <Column field="package" header="Package" />
        <Column header="Link" body={linkBody} />
        <Column header="Post" body={postBody} /> {/* ✅ NEW */}
        <Column header="Customer By" body={joinedByBody} />
        <Column field="date" header="Date / Time" />
        <Column header="Action" body={actionBody} />
      </DataTable>

      {/* 🔥 Post Preview Dialog */}
      <Dialog
        visible={dialogVisible}
        onHide={() => setDialogVisible(false)}
        header="Post Preview"
        style={{ width: "500px" }}
      >
        {selectedPost && (
          <div className="space-y-4">
            {selectedPost.image && (
              <img
                src={selectedPost.image}
                alt="post"
                className="w-full rounded"
              />
            )}

            {selectedPost.video && (
              <video controls className="w-full rounded">
                <source src={selectedPost.video} type="video/mp4" />
              </video>
            )}

            {selectedPost.audio && (
              <audio controls className="w-full">
                <source src={selectedPost.audio} type="audio/mpeg" />
              </audio>
            )}

            {selectedPost.text && <p className="p-3">{selectedPost.text}</p>}
          </div>
        )}
      </Dialog>
    </div>
  );
};

export default CustomerLinkRequest;
